import { computed, onUnmounted, ref } from 'vue'

export const useTimer = (endTimestamp: number) => {
  // 参数是结束时间时间戳，返回值是 days hours minutes seconds
  // 使用 ref 存储当前时间，通过定时器定期更新使其响应式
  const now = ref(Date.now())

  // 每秒更新一次当前时间
  const interval = setInterval(() => {
    now.value = Date.now()
  }, 1000)

  // 组件卸载时清理定时器
  onUnmounted(() => {
    clearInterval(interval)
  })

  const diff = computed(() => Number(endTimestamp) - now.value)

  const days = computed(() => {
    return diff.value <= 0 ? 0 : Math.floor(diff.value / (1000 * 60 * 60 * 24))
  })
  const hours = computed(() => {
    return diff.value <= 0 ? 0 : Math.floor((diff.value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  })
  const minutes = computed(() => {
    return diff.value <= 0 ? 0 : Math.floor((diff.value % (1000 * 60 * 60)) / (1000 * 60))
  })
  const seconds = computed(() => {
    return diff.value <= 0 ? 0 : Math.floor((diff.value % (1000 * 60)) / 1000)
  })

  return {
    days,
    hours,
    minutes,
    seconds,
  }
}
